import { functions as fn } from "firebase";
import { SetGameDataRequest } from "@halfbrick/network-effect-web-shared";

export const setGameData = async (_: any, functions: fn.Functions, request: SetGameDataRequest):Promise<void> => {
  const setCall = functions.httpsCallable("setGameData");
  await setCall(request);
};
